import {Link} from 'react-router-dom';
import {useAssetsImage} from '~/pages/context/AssetsImageContext'
import './authlayout.css';

function AuthenticationLayout({children}) {
    const {getImageUrlById} = useAssetsImage();
    return (
        <main className='main'>
            <div className='container'>
                <div className='row flex-center auth-wrapper py-5'>
                    <div className='col-sm-10 col-md-8 col-lg-5 col-xl-5 col-xxl-3'>
                        <Link className="d-flex flex-center text-decoration-none mb-4" to="/home">
                            <div className="d-flex align-items-center fw-bolder fs-3 d-inline-block">
                                {
                                    getImageUrlById(39) &&
                                    <img src={getImageUrlById(39)} alt="breakthrough" width="58"/>
                                }
                            </div>
                        </Link>
                        {children}
                    </div>
                </div>
            </div>
            <footer className='text-center'>
                <span className="fs-9 pe-3">©2025 BreakThrough, Inc. All rights reserved.</span>
                <Link className="fs-9 fw-semibold pe-3" to="/home">Terms of use</Link>
                <Link className="fs-9 fw-semibold" to="/home">Privacy policy</Link>
            </footer>
        </main>
    )
}

export default AuthenticationLayout;